
import { List } from 'vant'
import { getTime, transform } from '../../../assets/js/xjpublic';
import { errorModal } from '../../../assets/js/xjcommon';

export default {
  name: 'home',
  components: {
    [List.name]: List
  },
  data () {
    return {
      // 公众号的名称
      // 当前页码
      nowPageTrip: 1,
      onePageNumberTrip: 20,
      tripList: [],
      // 行程统计
      statisticalData: {
        total_miles:0,
        rankRate:0,
        score_avg:0,
        total_time_using:0,
        avg_speed:0,
        max_speed:0,
        max_miles:0,
        total_times:0,
      },
      // 上拉刷新
      loadingGetTripList: false,
      finishedGetTripList: false,
      isFrist: true,
      imgURlimgURl: require('../../../assets/images/ic_no_data.png')
    }
  },
  methods: {
    initGetTripListFn () {
      if (!$cookies.get('imei')) {
        this.$router.push('/error?type=imei');
      }
      this.$toast.loading({
        overlay: true,
        duration: 0,
        message: '加载中...'
      });
      this.$axios.post('/v3/u/travel/list', { page: this.nowPageTrip,limit:15 })
        .then(response=>{
          // console.log(response);
          this.isFrist = false;
          this.loadingGetTripList = false;
          if (response.data.ret === 0) {
            // 加载状态结束
            let resData = response.data.data;
            if (resData.length > 0) {
              this.tripDataHandle(resData);
            } else {
              // 关闭加载状态
              this.$toast.clear();
            }
            // 判断是否还有数据
            if (this.onePageNumberTrip > resData.length) {
              this.finishedGetTripList = true;
            }
          } else {
            this.$toast.clear();
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取行程报告失败（' + response.data.ret + '）'
            })
          }
        })
        .catch((error) =>{
          this.isFrist = false;
          this.$toast.clear();
          errorModal(error, 201);
        })
    },
    // 数据处理
    tripDataHandle (resData) {
      const data = resData.map(item => {
        return {
          ...item,
          finishTimeShow: getTime.getFormatDateWithTxt(1,item.startTime),
          startToEnd: getTime.getFormatDate(2, item.startTime).substring(11, 16) + ' - ' + getTime.getFormatDate(2, item.finishTime).substring(11, 16),
          spaceText: item.space ? item.space.toFixed(1) : 0,
          usedTime:getTime.getPassedTimeWithTxt(item.startTime, item.finishTime),
          isAddDay:(new Date(item.finishTime)).getDate()-(new Date(item.startTime)).getDate(),
        }
      })

      // // 根据时间同一天，同一imei分组
      // const sameDay = data.reduce((total,item)=>{
      //   const getSameimeiAndDay = data.filter(itm=>itm.finishTimeShow === item.finishTimeShow && itm.imei === item.imei);
      //   total.push({
      //     finishTimeShow:item.finishTimeShow,
      //     imei:item.imei,
      //     children:getSameimeiAndDay,
      //   })
      //   return total;
      // },[])
      // const sortData = sameDay.reduce((t,item)=>{
      //     return t.find(i=>i.finishTimeShow===item.finishTimeShow && i.imei===item.imei) ? t : t.concat(item)
      // },[]);
      // 新数据添加到原数据
      this.tripList = this.tripList.concat(data);
      this.OriginTripList =resData;
      // 关闭加载状态
      this.$toast.clear();
    },

    getTripAddress (id) {
      this.$axios.post('/v3/u/travelReGeo', { _id: id })
        .then((response)=>{
          if (response.data.ret === 0) {
            const address = response.data.data
            this.tripList = this.tripList.map(item=>({
              ...item,
              startAddr:id===item._id?address.startAddr:item.startAddr,
              endAddr:id===item._id?address.endAddr:item.endAddr,
            }))
          } else {
            this.$toast.clear();
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取地址失败（' + response.data.ret + '）'
            })
          }
        })
        .catch(function (error) {
          _this.$toast.clear();
          errorModal(error, 208);
        })
    },


    // 获取总里程,/v3/u/travel/statisticalData(单个设备的行程统计数据),
    initTotalNumberFn () {
      this.$axios.post('/v3/u/travel/statisticalData', { imei: this.$store.state.nowImei })
        .then(response=>{
          const res = response.data
          if (res.ret === 0) {
            this.statisticalData = {...res.data,
              total_time_using:res.data.total_time_using?getTime.getPassedTimeWithTotal(res.data.total_time_using):0,
              score_avg:Math.floor(res.data.score_avg),
              increaseRate:(res.data.increaseRate)>0?Math.floor(res.data.increaseRate*100):Math.ceil(res.data.increaseRate*100)
            };
          } else {
            this.$toast.clear();
            this.$dialog({
              message: res.msg ? res.msg + '（' + res.ret + '）' : '获取行程统计失败（' + res.ret + '）'
            })
          }
        })
        .catch((error)=>{
          this.$toast.clear();
          errorModal(error, 212);
        })
    },
    // 上拉加载
    onLoadGetTripList () {
      if (this.isFrist) {return}
      this.nowPageTrip = this.nowPageTrip + 1;
      this.initGetTripListFn();
    },
    deleteTripReport(items) {
      this.$dialog.confirm({
        title: '删除',
        message: '您确定要删除该行程报告吗',
      })
        .then(() => {
          this.$toast.loading({
            overlay: true,
            duration: 0,
            message: '删除中...'
          });
          this.$axios.post('/v3/u/travel/deleteHistory', {
            ids: [items._id],
          }).then((response) => {
            this.$toast.clear()
            if (response.data.ret === 0) {
              this.nowPage = 1;
              this.tripList = [];
              this.initGetTripListFn()
              this.initTotalNumberFn();
            }else{
              this.$dialog({
                message: response.data.msg
              })
            }
          })
        })
        .catch(() => {
          // on cancel
        });
    },
    // 跳转到行程报告详情
    toTripDetailsPage (trackUrl) {
      // window.location.href = 'http://test.spreadwin.cn/services/frontpage/html/pathReport/HistoryDetails.html?v=v2&travelId=' + Id;
      window.location.href = trackUrl;
    }
  },
  created () {
    window.scrollTo(0,0);
    this.initGetTripListFn();
    this.initTotalNumberFn();
  }
}
